module.exports = __webpack_public_path__ + "static/media/img37.20c902a2.jpg";